// WebsiteStructure.js
import Header from './HeaderWebsite';
import { Outlet } from 'react-router-dom';
import Footer from './Footer';
import StickyCTA from '../component/StickyCTA'
const WebsiteStructure = () => {
  return (
    <>
    {/* // <div className="bg-white min-h-screen"> */}
      {/* <CentaurusSketches /> */}
      {/* // <div className="relative z-10"> */}
        <Header />
        {/* // <main> */}
          <Outlet />
        {/* // </main> */}
        <Footer />
        <StickyCTA />
      {/* // </div> */}
    {/* // </div> */}
    </>
  );
};

export default WebsiteStructure;